/** @format */
import { createTheme } from "@mui/material";
let theme = createTheme({
  typography: {
    fontFamily: `"Noto Sans", "Helvetica", "Arial", sans-serif`,
    h1: {
      fontSize: "48px",
    },
    h2: {
      fontSize: "32px",
    },
    h3: {
      fontSize: "26px",
    },
    h4: {
      fontSize: "24px",
    },
    h5: {
      fontSize: "20px",
    },
    h6: {
      fontSize: "18px",
    },
    subtitle1: {
      fontSize: "14px",
      fontWeight: "600",
    },
    subtitle2: {
      fontSize: "16px",
      fontWeight: "600",
    },
    body1: {
      fontSize: "12px",
    },
  }
});

theme = createTheme(theme, {
  typography: {
    small: {
      fontSize: "10px",
    },
    smallBold: {
      fontSize: "10px",
      fontWeight: "700",
    },
    smallSemiBold: {
      fontSize: "10px",
      fontWeight: "600",
    },
    bodyBold: {
      fontSize: "12px",
      fontWeight: "700",
    },
    bodySmallBold: {
      fontSize: "12px",
      fontWeight: "600",
    },
  },
  colorSchemes: {
    light: {
      primary: "#f08c81",
      third: "#FFD8D4",
      secondary: "#ffffff",
      textMain: "#373737",
      textGray: "#858585",
      warning: "#FFA500",
      success: "#28A745",
      info: "#17A2B8",
      error: "#DC3545",
      bgHover: "rgba(0, 117, 208, 0.1)",
    },
    dark: {
      primary: "#f08c81",
      third: "#FFD8D4",
      secondary: "#ffffff",
      textMain: "#373737",
      textGray: "#858585",
      warning: "#FFA500",
      success: "#28A745",
      info: "#17A2B8",
      error: "#DC3545",
      bgHover: "rgba(0, 117, 208, 0.1)",
    },
  }
});

export default theme;
